import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PrincipalComponent } from './principal/principal.component';
import { ApresentacaoComponent } from './apresentacao/apresentacao.component';
import { SobreComponent } from './sobre/sobre.component';
import { FaqComponent } from './faq/faq.component';
import { CursosComponent } from './cursos/cursos.component';
import { CursoComponent } from './cursos/curso/curso.component';
import { CursosListaComponent } from './cursos/cursos-lista/cursos-lista.component';
import { CursoResolver } from './shared/resolver/curso.resolver';
import { CursosResolver } from './shared/resolver/cursos.resolver';
import { PesquisaComponent } from './pesquisa/pesquisa.component';
import { PaginaNaoEncontradaComponent } from './pagina-nao-encontrada/pagina-nao-encontrada.component';
import { EixoTecnologicoComponent } from './eixo-tecnologico/eixo-tecnologico.component';
import { ApresentacaoResolver } from './shared/resolver/apresentacao.resolver';
import { FaqResolver } from './shared/resolver/faq.resolver';
import { PrincipalResolver } from './shared/resolver/principal.resolver';
import { PesquisaResolver } from './shared/resolver/pesquisa.resolver';
import { EixoTecResolver } from './shared/resolver/eixo-tecnologico.resolver';
import { CursosNaoPermitidosComponent } from './cursos/cursos-nao-permitidos/cursos-nao-permitidos.component';
import { SobreResolver } from './shared/resolver/sobre.resolver';
import { EixosResolver } from './shared/resolver/eixos.resolver';
import { CursosExperimentaisComponent } from './cursos/cursos-experimentais/cursos-experimentais.component';
import { SugestoesComponent } from './sugestoes/sugestoes.component';
import { ListaTermosComponent } from './lista-termos/lista-termos.component';
import { ListaTermosResolver } from './shared/resolver/lista-de-termos.resolver';
import { CursosMudaramNomeTabelaConvergenciaComponent } from './cursos/cursos-mudaram-nome-tabela-convergencia/cursos-mudaram-nome-tabela-convergencia.component';
import { CursosTabelaConvergenciaResolver } from './shared/resolver/cursos-tabela-convergencia.resolver';
import { CursosTabelaSubmissaoComponent } from './cursos/cursos-tabela-submissao/cursos-tabela-submissao.component';
import { CursosTabelaSubmissaoResolver } from './shared/resolver/cursos-tabela-submissao.resolver';
import { InstituicoesEnsinoComponent } from './instituicoes-ensino/instituicoes-ensino.component';
import { InstituicoesResolver } from './shared/resolver/instituicoes.resolver';
import { FiltroInstituicoesComponent } from './instituicoes-ensino/filtro-instituicoes.component';
import { InstituicaoFiltroResolver } from './shared/resolver/instituicao-filtro.resolver';
import { AreasTecnologicasResolver } from './shared/resolver/areas-tecnologicas.resolver';
import { AreaTecnologicaResolver } from './shared/resolver/area-tecnologica.resolver';
import { LegislacaoResolver } from './shared/resolver/legislacao.resolver';
import { LegislacaoComponent } from './legislacao/legislacao.component';
import { AreaTecnologicaComponent } from './area-tecnologica/area-tecnologica.component';
import { CursosConvergentesResolver } from './shared/resolver/cursos-convergentes.resolver';

const routes: Routes = [
  {
    path: '',
    component: PrincipalComponent,
    data: {
      breadcrumb: 'Principal',
      title: 'Catálogo Nacional de Cursos Técnicos',
    },
    resolve: {
      catalogo: PrincipalResolver,
    },
  },
  {
    path: 'apresentacao',
    component: ApresentacaoComponent,
    data: { breadcrumb: 'Apresentação', title: 'Apresentação' },
    resolve: { apresentacao: ApresentacaoResolver },
  },
  {
    path: 'expediente',
    component: SobreComponent,
    data: { breadcrumb: 'Expediente', title: 'Expediente' },
    resolve: {
      sobre: SobreResolver,
    },
  },
  {
    path: 'legislacao',
    component: LegislacaoComponent,
    data: { breadcrumb: 'Legislação', title: 'Legislação' },
    resolve: {
      legislacao: LegislacaoResolver,
    },
  },
  {
    path: 'cursos',
    component: CursosComponent,
    data: { breadcrumb: 'Todos os Cursos' },
    children: [
      {
        path: '',
        component: CursosListaComponent,
        data: { breadcrumb: '', title: 'Todos os Cursos' },
        resolve: {
          cursos: CursosResolver,
          eixos: EixosResolver,
        },
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
      },
      // {
      //   path: 'mudaram-nome',
      //   component: CursosMudaramNomeComponent,
      //   data: {
      //     breadcrumb: 'Cursos que mudaram de nome',
      //     title: 'Cursos que mudaram de nome',
      //   },
      // },
      {
        path: 'mudaram-nome-tabela-convergencia',
        component: CursosMudaramNomeTabelaConvergenciaComponent,
        data: {
          breadcrumb: 'Tabela de Convergência',
          title: 'Tabela de Convergência',
        },
        resolve: {
          cursosTabelaConvergencia: CursosConvergentesResolver,
        },
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
      },
      {
        path: 'tabela-submissao',
        component: CursosTabelaSubmissaoComponent,
        data: {
          breadcrumb: 'Tabela de Submissão',
          title: 'Tabela de Submissão',
        },
        resolve: {
          cursosTabelaSubmissao: CursosTabelaSubmissaoResolver,
        },
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
      },
      {
        path: 'nao-autorizados',
        component: CursosNaoPermitidosComponent,
        data: {
          breadcrumb: 'Cursos excluídos ou não incluídos',
          title: 'Cursos excluídos ou não incluídos',
        },
      },
      {
        path: 'experimentais',
        component: CursosExperimentaisComponent,
        data: {
          breadcrumb: 'Cursos em oferta experimental',
          title: 'Cursos em oferta experimental',
        },
      },
      {
        path: 'curso',
        component: CursoComponent,
        data: { breadcrumb: '{{curso.nome}}', title: '{{curso.nome}}' },
        resolve: {
          eixos: EixosResolver,
          areas: AreasTecnologicasResolver,
          curso: CursoResolver,
        },
      },
      {
        path: 'instituicoes-ensino',
        component: InstituicoesEnsinoComponent,
        data: { breadcrumb: 'Instituições ofertantes' },
        resolve: {
          instituicoes: InstituicoesResolver,
        },
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
      },
      {
        path: 'filtro-instituicoes',
        component: FiltroInstituicoesComponent,
        data: {
          breadcrumb: 'Resultados da pesquisa Instituições',
          title: 'Resultados da pesquisa Instituições',
        },
        resolve: {
          instituicoes: InstituicaoFiltroResolver,
        },
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
      },
      {
        path: 'eixo-tecnologico',
        component: EixoTecnologicoComponent,
        data: { breadcrumb: '{{eixo.nome}}', id: '{{eixo.id}}', title: '{{eixo.nome}}' },
        resolve: {
          eixo: EixoTecResolver,
          cursos: CursosResolver,
          areas: AreasTecnologicasResolver,
        },
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
      },
      // children: [
      {
        component: AreaTecnologicaComponent,
        path: 'area',
        data: { breadcrumb: '{{area.nome}}', title: '{{area.nome}}' },
        resolve: {
          eixo: EixoTecResolver,
          cursos: CursosResolver,
          area: AreaTecnologicaResolver
        },
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
        // ]
      },
    ],
  },
  {
    path: 'faq',
    component: FaqComponent,
    data: {
      breadcrumb: 'Perguntas Frequentes',
      title: 'Perguntas frequentes',
    },
    resolve: { faq: FaqResolver },
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
  },
  {
    path: 'pesquisa',
    component: PesquisaComponent,
    data: {
      breadcrumb: 'Resultados da pesquisa',
      title: 'Resultados da pesquisa',
    },
    resolve: { resultadoBusca: PesquisaResolver },
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
  },
  {
    path: 'eixo-tecnologico',
    component: EixoTecnologicoComponent,
    data: { breadcrumb: '{{eixo.nome}}', id: '{{eixo.id}}', title: '{{eixo.nome}}' },
    resolve: {
      eixo: EixoTecResolver,
      cursos: CursosResolver,
      areas: AreasTecnologicasResolver,
    },
    runGuardsAndResolvers: 'paramsOrQueryParamsChange',
    children: [
      {
        component: EixoTecnologicoComponent,
        path: 'area',
        data: { breadcrumb: '{{area.nome}}', title: '{{area.nome}}' },
        resolve: {
          area: AreaTecnologicaResolver
        },
        runGuardsAndResolvers: 'paramsOrQueryParamsChange',
      }
    ]
  },
  {
    path: 'envie-sugestao',
    component: SugestoesComponent,
    data: {
      breadcrumb: 'Envie sua sugestão de melhoria',
      title: 'Envie sua sugestão de melhoria',
    },
  },
  {
    path: 'lista-de-termos',
    component: ListaTermosComponent,
    data: {
      breadcrumb: 'Lista de Termos',
      title: 'Lista de termos',
    },
    resolve: {
      termos: ListaTermosResolver
    }
  },
  {
    path: 'pagina-nao-encontrada',
    component: PaginaNaoEncontradaComponent,
    data: {
      breadcrumb: 'Página não encontrada',
      title: 'Página não encontrada',
    },
  },
  { path: '**', redirectTo: '/pagina-nao-encontrada' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
